export var Align;
(function (Align) {
  Align["Left"] = "Left";
  Align["Right"] = "Right";
  Align["Center"] = "Center";
})(Align || (Align = {}));